export function isEmptyObject (obj) {
  return Object.keys(obj).length === 0
}

export function pluralize (count, singularString) {
  if (count === 1) {
    return singularString
  } else {
    switch (singularString) {
      case 'child':
        return 'children'
      case 'Child':
        return 'Children'
      default:
        return `${singularString}s`
    }
  }
}

export function delay (ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function sortByCreatedAtComparator (ascending = true) {
  return (a, b) => {
    if (ascending) {
      return new Date(b.created_at) - new Date(a.created_at)
    } else {
      return new Date(a.created_at) - new Date(b.created_at)
    }
  }
}

export function generateTempId () {
  return `local-${Date.now()}-${Math.floor(Math.random() * 1000)}`
}

export function normalizrResult (response, entitiesKey, resultKey) {
  return response.entities[entitiesKey][response.result[resultKey]]
}

export function flatten (list) {
  return list.reduce(
    (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []
  )
}

// Reference: http://stackoverflow.com/a/24053987/175830
export function isSameDay (dateA, dateB) {
  return dateA.toDateString() === dateB.toDateString()
}

export function truncate (original, length) {
  if (original.length >= length) {
    let string = original.substr(0, length - 3)
    // Don't end with a space before the ellipsis
    if (string.slice(-1) === ' ') {
      string = string.slice(0, -1)
    }
    string += '…'
    return string
  }

  return original
}

export function isHobnobAndroidClient () {
  return !!window.android
}

export function isHobnobIosClient () {
  return document.body.classList.contains('ios-client')
}

export function androidObject () {
  return window.android
}

const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

// Render a number like 905 as "$9.05"
export function displayCurrency (priceInCents, stripZeros = false) {
  const formattedNumber = currencyFormat.format(priceInCents / 100)
  if (stripZeros && formattedNumber.endsWith('.00')) {
    return formattedNumber.replace('.00', '')
  } else {
    return formattedNumber
  }
}

export function sumCount (ticket, type = 'count') {
  let total = 0
  for (let i = 0; i < ticket.length; i++) {
    total += ticket[i][type]
  }
  return total
}

export function deepCopyArray (array) {
  return JSON.parse(JSON.stringify(array))
}

export function changeTicketCounts (ticketCounts, ticketTypeId, count) {
  let tempTicketCounts = deepCopyArray(ticketCounts)

  const editedTicketType = tempTicketCounts.find(tt => tt.id === ticketTypeId)

  // Count the number of tickets that have been archived but have been summed
  // into the count displayed to the user so that we can subtract them when
  // updating the count
  const archivedTicketCount = tempTicketCounts.reduce((acc, ticketType) => {
    if (ticketType.id === ticketTypeId) {
      return acc
    } else if (ticketType.label === editedTicketType.label) {
      return acc + ticketType.count
    } else {
      return acc
    }
  }, 0)

  tempTicketCounts = tempTicketCounts.map(item => {
    if (item.id === ticketTypeId) {
      item.count = count - archivedTicketCount
    }
    return item
  })

  return tempTicketCounts
}

export function defaultPaymentMethod (paymentMethodsList) {
  let paymentMethod = paymentMethodsList.find(item => item.is_default)
  if (paymentMethod) {
    return paymentMethod
  }

  return paymentMethodsList.sort((method1, method2) => {
    const date1 = Date.parse(method1.inserted_at)
    const date2 = Date.parse(method2.inserted_at)

    if (date1 < date2) {
      return -1
    } else if (date1 > date2) {
      return 1
    } else {
      return 0
    }
  })[0]
}

export function timeSince (date) {
  const seconds = Math.floor((new Date() - date) / 1000)

  let interval = seconds / 31536000
  if (interval > 1) {
    const year = Math.floor(interval)
    return `${year} ${year === 1 ? 'year' : 'years'} ago`
  }

  interval = seconds / 2592000
  if (interval > 1) {
    const month = Math.floor(interval)
    return `${month} ${month === 1 ? 'month' : 'months'} ago`
  }

  interval = seconds / 86400
  if (interval > 1) {
    const days = Math.floor(interval)
    return `${days} ${days === 1 ? 'day' : 'days'} ago`
  }

  interval = seconds / 3600
  if (interval > 1) {
    const hours = Math.floor(interval)
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`
  }

  interval = seconds / 60
  if (interval > 1) {
    const minutes = Math.floor(interval)
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`
  }

  return Math.floor(seconds) + ' seconds ago'
}

export function capitalized (str) {
  return str.toLowerCase().replace(/(?:^|\s)\w/g, function (c) {
    return c.toUpperCase()
  })
}



// WEBPACK FOOTER //
// ./src/services/utils.js